<template>
  <div class="wrapper">
    <div>
      <a-skeleton
        class="loading-details-skeleton"
        v-if="loading"
        :avatar="{ shape: 'circle' }"
        :paragraph="false"
        :active="true"
      />
      <page-header v-else :avatar="avatar" :title="title" />
    </div>

    <header-tabs :selectedKeys="selectedKeys" :routes="routes" />

    <course-progress :courseId="$route.params.courseId" class="mb-24" />

    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { Course } from '@/api'
import HeaderTabsContent from '@/views/Layouts/HeaderTabsContent'
import HeaderTabs from '@/views/Layouts/HeaderTabsContent/HeaderTabs'
import CourseProgress from '@/components/common/CourseProgress'

export default {
  extends: HeaderTabsContent,
  components: {
    CourseProgress,
    HeaderTabs
  },
  computed: {
    service() {
      return Course
    },
    title() {
      return this.instance && this.instance.name
    },
    routes() {
      const params = this.$route.params
      return [
        {
          label: 'Szczegóły kursu',
          icon: 'laptop',
          to: `/kursant/kursy/szczegoly/${params.courseId}/info/`
        },
        {
          label: 'Kalendarz',
          icon: 'calendar',
          to: `/kursant/kursy/szczegoly/${params.courseId}/kalendarz/`
        },
        {
          label: 'Szczegóły lektora',
          icon: 'user',
          to: `/kursant/kursy/szczegoly/${params.courseId}/lektor/`
        },
        {
          label: 'Materiały dydaktyczne',
          icon: 'folder-open',
          to: `/kursant/kursy/szczegoly/${params.courseId}/materialy-dydaktyczne/`
        },
        {
          label: 'Historia zajęć',
          icon: 'history',
          to: `/kursant/kursy/szczegoly/${params.courseId}/historia-zajec/`
        }
      ]
    },
    params() {
      return this.$route.params.courseId
    }
  }
}
</script>
